import {ActionTree} from "vuex";
import {RestrictionItem, RestrictionFilterParams, RestrictionsState} from "@/store/sms/restrictions/types";
import {RootState} from "@/store/types";
import axios, { AxiosResponse } from "axios";

export const actions: ActionTree<RestrictionsState, RootState> = {
  async getRestrictions({commit}, filter: RestrictionFilterParams) {
    commit("setLoading", true);
    try {
      const resp: AxiosResponse<{ restrictions: RestrictionItem[] }> = await axios({
        url: "/acapi/sms/originator_restrictions",
        params: filter,
      });
      commit("setRestrictions", resp.data.restrictions);
      return resp;
    } catch (err) {
      throw err;
    } finally {
      commit("setLoading", false);
    }
  },
  async getRestrictionItem({commit}, id:number) {
    commit("setLoading", true);
    try {
      const resp: AxiosResponse<RestrictionItem> = await axios({
        url: `/acapi/sms/originator_restrictions/${id}`,
      });
      const restrictionItem: RestrictionItem = resp.data;
      restrictionItem.id = id;
      commit("setRestriction", restrictionItem);
      return restrictionItem;
    } catch (err) {
      throw err;
    } finally {
      commit("setLoading", false);
    }
  },
  async saveRestriction({commit,dispatch}, data:RestrictionItem) {
    commit("setLoading", true);
    try {
      const resp = await axios({
        method: data.id ? 'put' : 'post',
        url: `/acapi/sms/originator_restrictions/${data.id ?? ''}`,
        data: data
      });
      dispatch("getRestrictions");
      return resp;
    } catch (err) {
      throw err;
    } finally {
      commit("setLoading", false);
    }
  },
  async deleteRestriction({commit,dispatch}, data:RestrictionItem) {
    commit("setLoading", true);
    try {
      const resp = await axios({
        method: 'delete',
        url: `/acapi/sms/originator_restrictions/${data.id}`,
        data: data
      });
      dispatch("getRestrictions");
      return resp;
    } catch (err) {
      throw err;
    } finally {
      commit("setLoading", false);
    }
  },
}